export const allDietaryRestrictionsMock = {
  count: 17,
  next: null,
  previous: null,
  results: [
    {
      field_name: 'is_omnivore',
      id: 11,
      is_active: true,
      is_core: true,
      name: 'Omnivore',
      remark: '',
      selected: null,
      slug: 'omnivore',
      sort_order: 0,
      thumbnail: '',
      thumbnail_url: null,
    },
    {
      field_name: 'is_flexitarian',
      id: 12,
      is_active: true,
      is_core: true,
      name: 'Flexitarian',
      remark: '',
      selected: null,
      slug: 'flexitarian',
      sort_order: 0,
      thumbnail: '',
      thumbnail_url: null,
    },
    {
      field_name: 'is_garlic_free',
      id: 13,
      is_active: true,
      is_core: false,
      name: 'Garlic-Free',
      remark: '',
      selected: null,
      slug: 'garlic-free',
      sort_order: 0,
      thumbnail: '',
      thumbnail_url: null,
    },
    {
      field_name: 'is_onion_free',
      id: 14,
      is_active: true,
      is_core: false,
      name: 'Onion-Free',
      remark: '',
      selected: null,
      slug: 'onion-free',
      sort_order: 0,
      thumbnail: '',
      thumbnail_url: null,
    },
    {
      field_name: 'is_sesame_free',
      id: 15,
      is_active: true,
      is_core: false,
      name: 'Sesame-Free',
      remark: '',
      selected: null,
      slug: 'sesame-free',
      sort_order: 0,
      thumbnail: '',
      thumbnail_url: null,
    },
    {
      field_name: 'is_caffeine_free',
      id: 16,
      is_active: true,
      is_core: false,
      name: 'Caffeine-Free',
      remark: '',
      selected: null,
      slug: 'caffeine-free',
      sort_order: 0,
      thumbnail: '',
      thumbnail_url: null,
    },
    {
      field_name: 'is_grain_free',
      id: 17,
      is_active: true,
      is_core: false,
      name: 'Grain-Free',
      remark: '',
      selected: null,
      slug: 'grain-free',
      sort_order: 0,
      thumbnail: '',
      thumbnail_url: null,
    },
    {
      field_name: 'is_vegan',
      id: 1,
      is_active: true,
      is_core: true,
      name: 'Vegan',
      remark: "I don't eat meat, seafood, dairy, or eggs",
      selected: null,
      slug: 'vegan',
      sort_order: 1,
      thumbnail: '29087867-8ac2-4e7d-8e2b-5bd79f8a23f5.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/29087867-8ac2-4e7d-8e2b-5bd79f8a23f5.svg',
    },
    {
      field_name: 'is_vegetarian',
      id: 2,
      is_active: true,
      is_core: true,
      name: 'Vegetarian',
      remark: "I don't eat meat or seafood",
      selected: null,
      slug: 'vegetarian',
      sort_order: 2,
      thumbnail: '8824fe2e-bc37-4661-926b-15a572c05f37.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/8824fe2e-bc37-4661-926b-15a572c05f37.svg',
    },
    {
      field_name: 'is_pescatarian',
      id: 3,
      is_active: true,
      is_core: true,
      name: 'Pescatarian',
      remark: "I don't eat meat",
      selected: null,
      slug: 'pescatarian',
      sort_order: 3,
      thumbnail: 'fd2e82f6-4524-4f94-a2fe-325b77913573.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/fd2e82f6-4524-4f94-a2fe-325b77913573.svg',
    },
    {
      field_name: 'is_dairy_free',
      id: 4,
      is_active: true,
      is_core: false,
      name: 'Dairy-Free',
      remark: '',
      selected: null,
      slug: 'dairy-free',
      sort_order: 4,
      thumbnail: '8e462d92-398f-4212-8e01-31fb1377fe8b.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/8e462d92-398f-4212-8e01-31fb1377fe8b.svg',
    },
    {
      field_name: 'is_gluten_free',
      id: 5,
      is_active: true,
      is_core: false,
      name: 'Gluten-Free',
      remark: '',
      selected: null,
      slug: 'gluten-free',
      sort_order: 5,
      thumbnail: '74c4144e-a56f-497f-a7f7-42a81554fbf3.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/74c4144e-a56f-497f-a7f7-42a81554fbf3.svg',
    },
    {
      field_name: 'is_soy_free',
      id: 6,
      is_active: true,
      is_core: false,
      name: 'Soy-Free',
      remark: '',
      selected: null,
      slug: 'soy-free',
      sort_order: 6,
      thumbnail: '7f2bfea0-7831-4843-9007-f996a61ceaaa.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/7f2bfea0-7831-4843-9007-f996a61ceaaa.svg',
    },
    {
      field_name: 'is_nut_free',
      id: 7,
      is_active: true,
      is_core: false,
      name: 'Tree Nut-Free',
      remark: '',
      selected: null,
      slug: 'tree-nut-free',
      sort_order: 7,
      thumbnail: '9551212f-5be8-449f-bf9d-54d1eb453f90.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/9551212f-5be8-449f-bf9d-54d1eb453f90.svg',
    },
    {
      field_name: 'is_peanut_free',
      id: 8,
      is_active: true,
      is_core: false,
      name: 'Peanut-Free',
      remark: '',
      selected: null,
      slug: 'peanut-free',
      sort_order: 8,
      thumbnail: 'a4c21a3d-05b1-4b9a-a12f-eb775545b032.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/a4c21a3d-05b1-4b9a-a12f-eb775545b032.svg',
    },
    {
      field_name: 'is_egg_free',
      id: 9,
      is_active: true,
      is_core: false,
      name: 'Egg-Free',
      remark: '',
      selected: null,
      slug: 'egg-free',
      sort_order: 9,
      thumbnail: 'e76de976-9300-47c2-82a9-5eeb5411377f.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/e76de976-9300-47c2-82a9-5eeb5411377f.svg',
    },
    {
      field_name: 'is_shellfish_free',
      id: 10,
      is_active: true,
      is_core: false,
      name: 'Shellfish-Free',
      remark: '',
      selected: null,
      slug: 'shellfish-free',
      sort_order: 10,
      thumbnail: '2294f1da-dc1d-4cd6-a3ff-fd01437f4b75.svg',
      thumbnail_url:
        'https://d219o304zcx1el.cloudfront.net/2294f1da-dc1d-4cd6-a3ff-fd01437f4b75.svg',
    },
  ],
};
